import React from 'react';
import PropTypes from 'prop-types';
import { withGoogleSheets } from 'react-db-google-sheets';
import { DataLink, Notification } from '../../components';
import { formatHomeTitle } from '../../utils';

const Home = ({ db: { home: data, upcomingtravel } }) => {
  const title = data.find(d => d.key === 'title').value;
  const intro = data.find(d => d.key === 'intro').value;
  const announcement = data.find(d => d.key === 'announcement').value;
  const travels = upcomingtravel.filter(u => u.done === '0');

  return (
    <div className="home-area padding-section">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10 col-12">
            <div className="home-content">
              <h1>
                <span
                  dangerouslySetInnerHTML={{
                    __html: formatHomeTitle(title)
                  }}
                />
              </h1>
              <p
                className="content-paragraph"
                dangerouslySetInnerHTML={{ __html: intro }}
              />
              <div className="content-paragraph-caption color-theme">
                <DataLink to="/about">Jawns?</DataLink>
                &nbsp;|&nbsp;
                <DataLink to="/news">Latest news</DataLink>
              </div>
              <Notification>{announcement}</Notification>
              <div className="upcoming-travel">
                <span className="title">Upcoming Travel: </span>
                {travels.map((travel, index) => (
                  <span key={travel.id}>
                    {index !== 0 && <span className="color-theme"> | </span>}
                    <span className="event-name">
                      <DataLink to={travel.event_url}>{travel.event}</DataLink>
                    </span>
                    {` ${travel.city} - ${travel.date}${
                      travel.reasoning ? ` (${travel.reasoning})` : ''
                    }`}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

Home.propTypes = {
  db: PropTypes.shape({
    home: PropTypes.arrayOf(PropTypes.object),
    upcomingtravel: PropTypes.arrayOf(PropTypes.object)
  })
};

export default withGoogleSheets(['home', 'upcomingtravel'])(Home);
